import React from 'react'
import { Link } from 'react-router-dom'
import {BsLinkedin, BsGithub, BsYoutube, BsInstagram, BsFacebook} from 'react-icons/bs'
import newsletter from '../images/newsletter.png'
const Footer = () => {
  return (
    <>
      <footer className='py-4'>
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col-5">
              <div className="footer-top-data d-flex gap-30 align-items-center">
                <img src={newsletter} alt="newsletter" />
                <h2 className='text-white mb-0'>Sign up for Newsletter</h2>
              </div>
            </div>
            <div className="col-7">
              <div className="input-group">
                <input type="text" className="form-control py-2" placeholder="Your Email Address"  aria-describedby='basic-addon2' />
                <span className="input-group-text p-2" id='basic-addon2'>
                      Subscribe
                </span>
              </div>                                     
            </div>
          </div>
        </div>

      </footer>
      <footer className='py-4'>
        <div className="container-xxl">
          <div className="row">
            <div className="col-4">
              <h4 className="text-white mb-4">Contact Us</h4>
              <div>
                <address className="text-white fs-6">
                  Hno:1001 Dasht-i-Barchi, <br /> District 13th, Kabul <br />
                  Afghnistan
                </address>
                <a href="tel:+92 799225732" className="text-white mt-3 mb-3 d-block">+93 799225732</a>
                <a href="mailto:fayeq.rahmat@gmail.com" className="text-white mt-3 mb-3 d-block">fayeq.rahmat@gmail.com</a>
                <div className="social-icons d-flex align-items-center gap-15">
                  <Link to="#">
                    <BsLinkedin className='text-white fs-4'/>
                  </Link>
                  <Link to="#">
                    <BsInstagram className='text-white fs-4'/>
                  </Link>
                  <Link to="#">
                    <BsYoutube className='text-white fs-4'/>
                  </Link>
                  <Link to="#">
                    <BsGithub className='text-white fs-4'/>
                  </Link>
                  <Link to="#">
                    <BsFacebook className='text-white fs-4'/>
                  </Link>
                 
                </div>
              </div>
            </div>
            <div className="col-3">
              <h4 className="text-white mb-4">Information</h4>
              <div className="footer-link d-flex flex-column">
                <Link to="/privacy-policy" className="text-white py-2 mb-1">Privacy Policy</Link>
                <Link to="/refund-policy" className="text-white py-2 mb-1">Refund Policy</Link>
                <Link to="/shipping-policy" className="text-white py-2 mb-1">Shipping Policy</Link>
                <Link to="/term-conditions" className="text-white py-2 mb-1">Terms & Conditions</Link>
                <Link to="/blogs" className="text-white py-2 mb-1">Blogs</Link>
              </div>
            </div>
            <div className="col-3">
              <h4 className="text-white mb-4">Account</h4>
                <div className="footer-link d-flex flex-column">
                  <Link to="about" className="text-white py-2 mb-1">About Us</Link>
                  <Link to="/faq" className="text-white py-2 mb-1">Faq</Link>
                  <Link to="/contact" className="text-white py-2 mb-1">Contact</Link>
                </div>
            </div>
            <div className="col-2">
              <h4 className="text-white mb-4">Quick Links</h4>
              <div className="footer-link d-flex flex-column">
                <Link className="text-white py-2 mb-1">Laptops</Link>
                <Link className="text-white py-2 mb-1">Headphones</Link>
                <Link className="text-white py-2 mb-1">Tablets</Link>
                <Link className="text-white py-2 mb-1">Watch</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <footer className='py-4'>
        <div className="container-xxl">
          <div className="row">
            <div className="col-12">
              <p className="text-center text-white mb-0">
                &copy; {new Date().getFullYear()}; Powered by Rahmat
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer